import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IAuthModalState {
  isOpen: boolean;
  step: number;
  isRequired: boolean;
  continue: boolean;
  ticketId?: number | null;
  data: {
    phone: string;
    code: string;
    age: number;
    role: string | null;
    region: number | null;
    subjectIds: number[];
    first_name: string;
    last_name: string;
    birthday: string;
    gender: string;
  };
}

const initialState: IAuthModalState = {
  isOpen: false,
  step: 1,
  isRequired: false,
  continue: false,
  ticketId: null,
  data: {
    phone: '',
    code: '',
    age: 20,
    role: null,
    region: null,
    subjectIds: [],
    first_name: '',
    last_name: '',
    birthday: '',
    gender: ''
  }
};

const authModalSlice = createSlice({
  name: 'auth-modal',
  initialState,
  reducers: {
    openAuthModal: state => {
      state.isOpen = true;
    },
    closeAuthModal: state => {
      state.isOpen = false;
    },
    nextStep: state => {
      state.step += 1;
    },
    prevStep: state => {
      if (state.step > 1) {
        state.step -= 1;
      }
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    setRequiredModal: state => {
      state.isRequired = true;
    },
    setContinue: state => {
      state.continue = true;
    },
    setPhone: (state, action: PayloadAction<string>) => {
      state.data.phone = action.payload;
    },
    setRole: (state, action: PayloadAction<string | null>) => {
      state.data.role = action.payload;
    },
    setAge: (state, action: PayloadAction<number>) => {
      state.data.age = action.payload;
    },
    setRegion: (state, action: PayloadAction<number | null>) => {
      state.data.region = action.payload;
    },
    setSubject: (state, action: PayloadAction<number[]>) => {
      state.data.subjectIds = action.payload;
    },
    setTicket: (state, action: PayloadAction<number | undefined>) => {
      state.ticketId = action.payload;
    }
  }
});

export const {
  openAuthModal,
  closeAuthModal,
  nextStep,
  prevStep,
  setStep,
  setRequiredModal,
  setContinue,
  setPhone,
  setRole,
  setAge,
  setRegion,
  setSubject,
  setTicket
} = authModalSlice.actions;
export const authModalReducer = authModalSlice.reducer;
